const shortTextAndImage = {
  displayField: 'title',
  name: 'Short Text And Image',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'imgAssetContentful',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: true,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'imgFocalPoint',
      name: 'img',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'ctaText',
      name: 'CTA Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'CTA Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'shortTextAndImage',
    version: 38,
    updatedAt: '2023-08-03T14:35:19.154Z'
  }
};
export default shortTextAndImage;